import api from './api';

const leftoverService = {
  // Get leftover summary for a date
  getSummary: async (date) => {
    const response = await api.get(`/api/leftover/summary?date=${date}`);
    return response.data;
  },

  // Get cow/buffalo split summary for a date
  getSplitSummary: async (date) => {
    const response = await api.get(`/api/leftover/split-summary?date=${date}`);
    return response.data;
  },

  // Get all leftover history
  getAllLeftovers: async () => {
    const response = await api.get('/api/leftover');
    return response.data;
  },

  // Sell leftover milk (admin only)
  sellLeftover: async (data) => {
    const response = await api.post('/api/leftover/sell', data);
    return response.data;
  },
addBackdateProduction: async (data) => {
    const response = await api.post('/api/leftover/backdate', data);
    return response.data;
  },

};

export default leftoverService;